<template>
    <section class="value-restriction-view">
        <HeaderComponent :title="'Limites de consumo (valor)'" />

        <div class="extract-container">
            <div class="actions">
                <div class="icon" @click="showAddRestriction">
                    <i class="fa fa-square-plus fa-2xl fa-regular icon"></i>
                </div>
            </div>

            <div class="list-fields">
                <div v-for="(field, key) in fields" :key="key" class="list-field">
                    <h1 v-text="field"></h1>
                </div>
            </div>

            <div class="list" v-if="Object.values(getValueRestrictions).length > 0">
                <div v-if="loading" class="loading">
                    <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                </div>
                <div v-else class="list-item" v-for="(item, key) in getValueRestrictions" :key="key" @click="editValueRestriction(item)">
                    <div class="list-item-field">
                        <h1 v-text="item.NMFAMILISALD"></h1>
                    </div>
                    <div class="list-item-field">
                        <h1 class="limit" v-text="formatValue(item.VRCONSDIARAL)"></h1>
                    </div>
                </div>
            </div>
            <div v-else  class="no-results">
                <div v-if="loading">
                    <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                </div>
                <h1 v-else>Não foram encontrados resultados</h1>
            </div>
        </div>

        <AddValueRestrictionComponent
            :unrestrictedFamilies="unrestrictedFamilies"
            @addRestriction="addRestriction"
        />

        <EditValueRestrictionComponent
            :schoolName="selectedStore.NMFAMILISALD"
            :schoolLimit="selectedStore.VRCONSDIARAL"
            @updateLimit="updateLimit"
            @deleteRestriction="deleteRestriction"
        />

        <ModalInfo :modalOpen="restFamModalOpen" @closeModal="restFamModalOpen = false" />
    </section>
</template>

<script>
import { showSuccessNotification, showAlertNotification } from '@/libs/Util.js'
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import AddValueRestrictionComponent from '@/components/bottom-popups/AddValueRestrictionComponent.vue'
import EditValueRestrictionComponent from '@/components/bottom-popups/EditValueRestrictionComponent.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import { mapActions, mapGetters } from 'vuex'
import { loadValueRestrictions, updateValueRestriction, getUnrestrictedFamilies, addValueRestriction, deleteValueRestriction } from '@/components/controllers/ValueRestrictionController'

export default {
    name: 'ValueRestrictionView',
    components: {
        HeaderComponent,
        EditValueRestrictionComponent,
        AddValueRestrictionComponent,
        ModalInfo
    },
    data () {
        return {
            fields: ['Loja', 'Limite Diário'],
            loading: false,
            searchText: '',
            selectedStore: {},
            unrestrictedFamilies: [],
            restFamModalOpen: false
        }
    },
    computed: {
        ...mapGetters(['getValueRestrictions'])
    },
    methods: {
        ...mapActions(['changeEditValueRestrictionMenuVisibility', 'changeAddValueRestrictionMenuVisibility', 'showModalInfo']),
        formatValue: function (value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        editValueRestriction: function (item) {
            this.selectedStore = item
            this.changeEditValueRestrictionMenuVisibility()
        },
        updateLimit: function (limit) {
            if (limit === this.selectedStore.VRCONSDIARAL) {
                showAlertNotification({
                    title: '',
                    text: 'O limite informado é igual ao limite atual'
                })
                return
            }
            updateValueRestriction(
                this.selectedStore.CDFAMILISALD,
                limit
            ).then((res) => {
                if (res.rowsAffected) {
                    showSuccessNotification({
                        title: '',
                        text: 'Limite atualizado com sucesso'
                    })
                }
                this.loading = true
                loadValueRestrictions().then(() => {
                    this.loading = false
                })
            })
        },
        deleteRestriction: function () {
            deleteValueRestriction(this.selectedStore.CDFAMILISALD).then((res) => {
                if (res.rowsAffected) {
                    showSuccessNotification({
                        title: '',
                        text: 'Restrição deletada com sucesso'
                    })
                }
                this.loading = true
                loadValueRestrictions().then(() => {
                    this.loading = false
                })
            })
        },
        showAddRestriction: function () {
            getUnrestrictedFamilies().then((families) => {
                if (families.length > 0) {
                    this.unrestrictedFamilies = families
                    this.changeAddValueRestrictionMenuVisibility()
                } else {
                    this.restFamModalOpen = true
                    this.showModalInfo({
                        type: 'default',
                        text: 'Não há lojas disponíveis para a restrição diária.',
                        icon: 'fa-solid fa-circle-exclamation'
                    })
                }
            })
        },
        addRestriction: function (CDFAMILISALD, limit) {
            addValueRestriction(CDFAMILISALD, limit).then((res) => {
                if (res.rowsAffected) {
                    showSuccessNotification({
                        title: '',
                        text: 'Limite adicionado com sucesso'
                    })
                }
                this.loading = true
                loadValueRestrictions().then(() => {
                    this.loading = false
                })
            })
        }
    },
    created () {
        this.loading = true
        loadValueRestrictions().then(() => {
            this.loading = false
        })
    }
}
</script>

<style lang="less" scoped>
.extract-container{
    .actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
    }

    .export {
        display: flex;
        align-items: center;
        border: 1px solid rgba(0, 0, 0, 0.18);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 50px;
        box-sizing: border-box;
        padding: 5px 10px;
        border-radius: 5px;

        i {
            padding-bottom: 4px;
        }
    }

    .search {
        display: flex;
        align-items: center;
        margin-top: 30px;
        // grey background
        background-color: #d9d9d963;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px 10px;
        position: relative;

        input {
            border: none;
            outline: none;
            background-color: transparent;
            font-size: 18px;
            font-family: Gellix;
            width: 100%;
        }

        i {
            position: absolute;
            right: 10px;
            color: gray;
        }
    }

    .list-fields {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
        padding: 0 4px;
        h1 {
            margin-bottom: 10px;
            font-weight: 600;
        }
    }

    .list {
        height: calc(100vh - 167px);
        overflow-y: auto;
        padding: 0 4px;

        &::-webkit-scrollbar {
            display: none;
        }

        .loading {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .list-item {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding-bottom: 20px;
        padding: 20px 10px;
        border: 1px solid var(--cardBorder);
        box-shadow: 2px 2px 4px var(--cardBorder);
        border-radius: 5px;

        .list-item-field {
            max-width: 50%;
            h1 {
                font-size: 16px;
            }
            .limit {
                font-weight: 600;
                text-align: right;
            }
        }

        &:last-of-type {
            margin-bottom: 20px;
        }
    }

    .no-results {
        display: flex;
        justify-content: center;
        font-size: 20px;
        margin-top: 20px;

        h1 {
            font-weight: 500;
        }
    }
}

</style>
